export default "__VITE_ASSET__BOIXf4Ii__"